export const SUPPORTED_UPLOAD_EXTENSIONS = new Set([
  "pdf", "docx", "xlsx", "xls", "txt", "csv", "jpg", "jpeg", "png", "webp"
]);

export const MAX_UPLOAD_BYTES = 15 * 1024 * 1024;
export const MAX_FILES_PER_UPLOAD = 5;

function extensionFor(filename = "") {
  const parts = filename.toLowerCase().split(".");
  return parts.length > 1 ? parts.pop() : "";
}

export function validateSelectedFiles(files = []) {
  if (!files.length) return "Choose at least one file to upload.";
  if (files.length > MAX_FILES_PER_UPLOAD) {
    return `Upload no more than ${MAX_FILES_PER_UPLOAD} files at once.`;
  }

  for (const file of files) {
    const extension = extensionFor(file.name);
    if (!SUPPORTED_UPLOAD_EXTENSIONS.has(extension)) {
      return `${file.name} is not supported. Choose PDF, DOCX, XLSX, XLS, TXT, CSV, JPG, JPEG, PNG, or WEBP.`;
    }
    if (file.size === 0) return `${file.name} is empty and cannot be processed.`;
    if (file.size > MAX_UPLOAD_BYTES) return `${file.name} exceeds the 15MB file-size limit.`;
  }

  return null;
}
